/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient } from "./http-client";
export class Api extends HttpClient {
  /**
   * No description
   *
   * @tags AppLogs
   * @name GetAppReqJwtLogsWithPagination
   * @summary 取得 AppReqJWT Log 分頁列表
   * @request POST:/api/AppLogs/appreqjwt/list
   * @secure
   */
  getAppReqJwtLogsWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/AppLogs/appreqjwt/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AppLogs
   * @name GetAppGetDataLogsWithPagination
   * @summary 取得 AppGetData Log 分頁列表
   * @request POST:/api/AppLogs/appgetdata/list
   * @secure
   */
  getAppGetDataLogsWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/AppLogs/appgetdata/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name GetToken
   * @request GET:/api/auth/token
   * @secure
   */
  getToken = (params = {}) =>
    this.request({
      path: `/api/auth/token`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name Login
   * @request POST:/api/auth/login
   * @secure
   */
  login = (data, params = {}) =>
    this.request({
      path: `/api/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name AccountPasswordLogin
   * @request POST:/api/auth/account-password-login
   * @secure
   */
  accountPasswordLogin = (data, params = {}) =>
    this.request({
      path: `/api/auth/account-password-login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name CheckRegistration
   * @request POST:/api/auth/check-registration
   * @secure
   */
  checkRegistration = (data, params = {}) =>
    this.request({
      path: `/api/auth/check-registration`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name Register
   * @request POST:/api/auth/register
   * @secure
   */
  register = (data, params = {}) =>
    this.request({
      path: `/api/auth/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name AccountPasswordRegister
   * @request POST:/api/auth/account-password-register
   * @secure
   */
  accountPasswordRegister = (data, params = {}) =>
    this.request({
      path: `/api/auth/account-password-register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Bulletins
   * @name GetBulletinsWithPagination
   * @summary 取得分頁的公佈欄列表
   * @request GET:/api/Bulletins
   * @secure
   */
  getBulletinsWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/Bulletins`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bulletins
   * @name CreateBulletin
   * @summary 新增公佈欄
   * @request POST:/api/Bulletins
   * @secure
   */
  createBulletin = (data, params = {}) =>
    this.request({
      path: `/api/Bulletins`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bulletins
   * @name GetBulletin
   * @summary 取得指定的公佈欄
   * @request GET:/api/Bulletins/{id}
   * @secure
   */
  getBulletin = (id, params = {}) =>
    this.request({
      path: `/api/Bulletins/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Bulletins
   * @name UpdateBulletin
   * @summary 更新公佈欄
   * @request POST:/api/Bulletins/update/{id}
   * @secure
   */
  updateBulletin = (id, data, params = {}) =>
    this.request({
      path: `/api/Bulletins/update/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Bulletins
   * @name DeleteBulletin
   * @summary 刪除公佈欄
   * @request POST:/api/Bulletins/delete/{id}
   * @secure
   */
  deleteBulletin = (id, params = {}) =>
    this.request({
      path: `/api/Bulletins/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags BulletinAttachments
   * @name UploadBulletinAttachment
   * @summary 上傳公告附件
   * @request POST:/api/Bulletins/{bulletinId}/attachments
   * @secure
   */
  uploadBulletinAttachment = (bulletinId, data, params = {}) =>
    this.request({
      path: `/api/Bulletins/${bulletinId}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags BulletinAttachments
   * @name GetBulletinAttachments
   * @summary 取得公告附件列表
   * @request GET:/api/Bulletins/{bulletinId}/attachments
   * @secure
   */
  getBulletinAttachments = (bulletinId, params = {}) =>
    this.request({
      path: `/api/Bulletins/${bulletinId}/attachments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags BulletinAttachments
   * @name DownloadBulletinAttachment
   * @summary 下載公告附件
   * @request GET:/api/Bulletins/attachments/download/{attachmentId}
   * @secure
   */
  downloadBulletinAttachment = (attachmentId, params = {}) =>
    this.request({
      path: `/api/Bulletins/attachments/download/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags BulletinAttachments
   * @name DeleteBulletinAttachment
   * @summary 刪除公告附件
   * @request POST:/api/Bulletins/attachments/delete/{attachmentId}
   * @secure
   */
  deleteBulletinAttachment = (attachmentId, params = {}) =>
    this.request({
      path: `/api/Bulletins/attachments/delete/${attachmentId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Common
   * @name GetCounties
   * @request GET:/api/common/Counties
   * @secure
   */
  getCounties = (params = {}) =>
    this.request({
      path: `/api/common/Counties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Common
   * @name GetTowns
   * @request GET:/api/common/Towns/{countryId}
   * @secure
   */
  getTowns = (countryId, params = {}) =>
    this.request({
      path: `/api/common/Towns/${countryId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Common
   * @name GetVillages
   * @request GET:/api/common/Villages/{townId}
   * @secure
   */
  getVillages = (townId, params = {}) =>
    this.request({
      path: `/api/common/Villages/${townId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomUsers
   * @name GetCustomUsersWithPagination
   * @summary 取得分頁的SDK申請單聯絡人列表
   * @request GET:/api/CustomUsers
   * @secure
   */
  getCustomUsersWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/CustomUsers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomUsers
   * @name CreateCustomUser
   * @summary 新增SDK申請單聯絡人
   * @request POST:/api/CustomUsers
   * @secure
   */
  createCustomUser = (data, params = {}) =>
    this.request({
      path: `/api/CustomUsers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomUsers
   * @name GetCustomUser
   * @summary 取得指定的SDK申請單聯絡人
   * @request GET:/api/CustomUsers/{id}
   * @secure
   */
  getCustomUser = (id, params = {}) =>
    this.request({
      path: `/api/CustomUsers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomUsers
   * @name UpdateCustomUser
   * @summary 更新SDK申請單聯絡人
   * @request POST:/api/CustomUsers/update/{id}
   * @secure
   */
  updateCustomUser = (id, data, params = {}) =>
    this.request({
      path: `/api/CustomUsers/update/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomUsers
   * @name DeleteCustomUser
   * @summary 刪除SDK申請單聯絡人
   * @request POST:/api/CustomUsers/delete/{id}
   * @secure
   */
  deleteCustomUser = (id, params = {}) =>
    this.request({
      path: `/api/CustomUsers/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestExecutes
   * @name GetTestExecutesWithPagination
   * @summary 取得分頁的參數列表
   * @request GET:/api/TestExecutes
   * @secure
   */
  getTestExecutesWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/TestExecutes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GeStaticFile
   * @summary 靜態檔案下載
   * @request GET:/api/StaticFile/{fileNmae}
   * @secure
   */
  geStaticFile = (fileNmae, params = {}) =>
    this.request({
      path: `/api/StaticFile/${fileNmae}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name GetOrganizationsWithPagination
   * @summary 取得分頁的機構列表
   * @request GET:/api/Organizations
   * @secure
   */
  getOrganizationsWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/Organizations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name CreateOrganization
   * @summary 新增機構
   * @request POST:/api/Organizations
   * @secure
   */
  createOrganization = (data, params = {}) =>
    this.request({
      path: `/api/Organizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name GetOrganization
   * @summary 取得機構
   * @request GET:/api/Organizations/{unifiedNumber}
   * @secure
   */
  getOrganization = (unifiedNumber, params = {}) =>
    this.request({
      path: `/api/Organizations/${unifiedNumber}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name UpdateOrganization
   * @summary 更新機構
   * @request POST:/api/Organizations/update/{id}
   * @secure
   */
  updateOrganization = (id, data, params = {}) =>
    this.request({
      path: `/api/Organizations/update/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Organizations
   * @name DeleteOrganization
   * @summary 刪除機構
   * @request POST:/api/Organizations/delete/{id}
   * @secure
   */
  deleteOrganization = (id, params = {}) =>
    this.request({
      path: `/api/Organizations/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Params
   * @name GetParamsWithPagination
   * @summary 取得分頁的參數列表
   * @request GET:/api/Params
   * @secure
   */
  getParamsWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/Params`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Params
   * @name CreateParam
   * @summary 新增參數
   * @request POST:/api/Params
   * @secure
   */
  createParam = (data, params = {}) =>
    this.request({
      path: `/api/Params`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Params
   * @name GetParam
   * @summary 取得參數
   * @request GET:/api/Params/{id}
   * @secure
   */
  getParam = (id, params = {}) =>
    this.request({
      path: `/api/Params/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Params
   * @name UpdateParam
   * @summary 更新參數
   * @request POST:/api/Params/update/{id}
   * @secure
   */
  updateParam = (id, data, params = {}) =>
    this.request({
      path: `/api/Params/update/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Params
   * @name DeleteParam
   * @summary 刪除參數
   * @request POST:/api/Params/delete/{id}
   * @secure
   */
  deleteParam = (id, params = {}) =>
    this.request({
      path: `/api/Params/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Permissions
   * @name GetPermissions
   * @request GET:/api/Permissions
   * @secure
   */
  getPermissions = (params = {}) =>
    this.request({
      path: `/api/Permissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name GetSdkCasesWithPagination
   * @summary 取得分頁的 SDK 案件列表
   * @request POST:/api/SdkCases/list
   * @secure
   */
  getSdkCasesWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/SdkCases/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name GetSdkCase
   * @summary 取得單一 SDK 案件
   * @request GET:/api/SdkCases/{caseId}
   * @secure
   */
  getSdkCase = (caseId, params = {}) =>
    this.request({
      path: `/api/SdkCases/${caseId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name CreateSdkCase
   * @summary 新增 SDK 案件
   * @request POST:/api/SdkCases
   * @secure
   */
  createSdkCase = (data, params = {}) =>
    this.request({
      path: `/api/SdkCases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name GetSdkKey
   * @summary 取得指定 SDK 案件特定環境的密鑰信息並下載為 JSON 檔案（雙環境支援）
   * @request POST:/api/SdkCases/{caseId}/KeyStores/{stage}/download
   * @secure
   */
  getSdkKey = (caseId, stage, params = {}) =>
    this.request({
      path: `/api/SdkCases/${caseId}/KeyStores/${stage}/download`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name UpdateSdkCaseStatus
   * @summary 更新指定案件特定環境的金鑰狀態（雙環境支援）
   * @request POST:/api/SdkCases/{caseId}/KeyStores/{stage}/status/update
   * @secure
   */
  updateSdkCaseStatus = (caseId, stage, data, params = {}) =>
    this.request({
      path: `/api/SdkCases/${caseId}/KeyStores/${stage}/status/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name GetKeyStoresWithPagination
   * @summary 取得分頁的密鑰列表
   * @request POST:/api/SdkCases/KeyStore/list
   * @secure
   */
  getKeyStoresWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/SdkCases/KeyStore/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SdkCases
   * @name DeleteSdkCase
   * @summary 刪除 SDK 案件
   * @request POST:/api/SdkCases/delete/{caseId}
   * @secure
   */
  deleteSdkCase = (caseId, params = {}) =>
    this.request({
      path: `/api/SdkCases/delete/${caseId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetUploadFilesWithPagination
   * @summary 取得分頁上傳檔案記錄列表
   * @request GET:/api/File
   * @secure
   */
  getUploadFilesWithPagination = (query, params = {}) =>
    this.request({
      path: `/api/File`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetUploadFile
   * @summary 取得指定的上傳檔案記錄
   * @request GET:/api/File/{id}
   * @secure
   */
  getUploadFile = (id, params = {}) =>
    this.request({
      path: `/api/File/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name CreateUploadFile
   * @summary 上傳檔案
   * @request POST:/api/File/{sdkCaseId}/{attachmentType}
   * @secure
   */
  createUploadFile = (sdkCaseId, attachmentType, data, params = {}) =>
    this.request({
      path: `/api/File/${sdkCaseId}/${attachmentType}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name UpdateUploadFile
   * @summary 更新上傳檔案記錄
   * @request POST:/api/File/update/{id}
   * @secure
   */
  updateUploadFile = (id, query, data, params = {}) =>
    this.request({
      path: `/api/File/update/${id}`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name DeleteUploadFile
   * @summary 刪除上傳檔案記錄
   * @request POST:/api/File/delete/{id}
   * @secure
   */
  deleteUploadFile = (id, params = {}) =>
    this.request({
      path: `/api/File/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Files
   * @name GetFile
   * @summary 下載檔案
   * @request GET:/api/File/download/{id}
   * @secure
   */
  getFile = (id, params = {}) =>
    this.request({
      path: `/api/File/download/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUsersWithPagination
   * @summary 取得分頁的使用者列表
   * @request POST:/api/Users/list
   * @secure
   */
  getUsersWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/Users/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetOrganizationUsersWithPagination
   * @summary 取得分頁的使用者列表
   * @request POST:/api/Users/orguserlist
   * @secure
   */
  getOrganizationUsersWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/Users/orguserlist`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUser
   * @summary 取得單一使用者
   * @request GET:/api/Users/{id}
   * @secure
   */
  getUser = (id, query, params = {}) =>
    this.request({
      path: `/api/Users/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetLoginLogsWithPagination
   * @summary 取得分頁的登入紀錄列表
   * @request POST:/api/Users/loginlogs
   * @secure
   */
  getLoginLogsWithPagination = (data, params = {}) =>
    this.request({
      path: `/api/Users/loginlogs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CreateUser
   * @summary 新增使用者
   * @request POST:/api/Users
   * @secure
   */
  createUser = (data, params = {}) =>
    this.request({
      path: `/api/Users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUser
   * @summary 更新使用者
   * @request POST:/api/Users/update/{id}
   * @secure
   */
  updateUser = (id, data, params = {}) =>
    this.request({
      path: `/api/Users/update/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name DeleteUser
   * @summary 刪除使用者
   * @request POST:/api/Users/delete/{id}
   * @secure
   */
  deleteUser = (id, params = {}) =>
    this.request({
      path: `/api/Users/delete/${id}`,
      method: "POST",
      secure: true,
      ...params,
    });
}
